<div class="tech-iframe">
  <form #formDigitalSign name="formDigitalSign" id="formDigitalSign" method="POST" [attr.action]="urlDigitalSign">
    <input type="hidden" id="saml_assertion" name="saml_assertion" [attr.value]="formDigitalSignXml" />
  </form>
</div>